import AxiosInstance from "./Axios";
import Cookies from "universal-cookie";

export async function getLogs({ type = "FULL", from, to } = {}) {
  const fromUnix = Number(from);
  const toUnix = Number(to);

  if (!Number.isFinite(fromUnix) || !Number.isFinite(toUnix)) {
    console.error("from and to are required unix timestamps");
    return null;
  }

  try {
    const cookies = new Cookies();
    const token = cookies.get("token");
    const params = new URLSearchParams({
      type: String(type || "FULL").trim() || "FULL",
      from: String(fromUnix),
      to: String(toUnix),
    });

    const res = await AxiosInstance.get(`/admin/logs?${params.toString()}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return res;
  } catch (error) {
    console.error("error in request:", error);
    return null;
  }
}

// ========================================================
// DEFAULT EXPORT
// ========================================================
const LogsService = {
  getLogs,
};

export default LogsService;
